import React, { useState } from "react"
import { Routes, Route, Navigate } from "react-router-dom";
import HomeLayout from './Layouts/HomeLayout';
import './App.css';
import SuspenseContainer from "./SuspenseContainer"
import FirstPage from "./Pages/FirstPage/FirstPage";
import { useAuth0 } from "@auth0/auth0-react";
import SmartoptLogo from "./assets/images/smartoptLogo.png";
import Constraint from "./Pages/Constraint";
import TruPunch5000 from "./Pages/TruPunch5000";
import TruBend7030 from "./Pages/TruBend7030";
import './i18n';
import PaymentAlertModal from "./Components/PaymentAlertModal/PaymentAlertModal";

const Dashboard = React.lazy(() => import("./Pages/Dashboard"))
const Support = React.lazy(() => import("./Pages/Support"))
const Machines = React.lazy(() => import("./Pages/Machines"))

const C120 = React.lazy(() => import("./Pages/C120"))
const P2_1 = React.lazy(() => import("./Pages/P2_1"))
const P2_2 = React.lazy(() => import("./Pages/P2_2"))
const P4L = React.lazy(() => import("./Pages/P4L"))
const PrimaPower1 = React.lazy(() => import('./Pages/PrimaPower1'))
const PrimaPower2 = React.lazy(() => import("./Pages/PrimaPower2"))
const S2 = React.lazy(() => import("./Pages/S2"))
const S4P4 = React.lazy(() => import("./Pages/S4P4"))
const S4Xe = React.lazy(() => import("./Pages/S4Xe"))
const S4XeP4 = React.lazy(() => import('./Pages/S4XeP4'))
const TC1000 = React.lazy(() => import("./Pages/TC1000"))
const TC3000R = React.lazy(() => import("./Pages/TC3000R"))
const VeriGirisi = React.lazy(() => import("./Pages/VeriGirisi"))
const Oee = React.lazy(() => import("./Pages/Oee"))
const ExcelUpload = React.lazy(() => import("./Pages/ExcelUpload"))

function App() {

  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div className="w-screen h-screen flex justify-center items-center m-auto bg-black">
      <img style={{ width: "300px" }} src={SmartoptLogo} alt="Smartopt Logo" />
    </div>;
  }

  if (!isAuthenticated) {
    return (

      <Routes>
        <Route path="/" element={<SuspenseContainer JsxElement={<FirstPage />} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="App">
        {/* <PaymentAlertModal /> */}
        <HomeLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/machines" replace />} />
            <Route path="/dashboard" element={<SuspenseContainer JsxElement={<Dashboard />} />} />
            <Route path="/support" element={<SuspenseContainer JsxElement={<Support />} />} />
            <Route path="/upload" element={<SuspenseContainer JsxElement={<ExcelUpload />} />} />
            <Route path="/veri-girisi" element={<SuspenseContainer JsxElement={<VeriGirisi />} />} />
            <Route path="/oee" element={<SuspenseContainer JsxElement={<Oee />} />} />
            <Route path="/constraint" element={<SuspenseContainer JsxElement={<Constraint />} />} />

            <Route path="/machines" element={<SuspenseContainer JsxElement={<Machines />} />}>
              <Route index element={<SuspenseContainer JsxElement={<Navigate to="/machines/C120" />} />} />
              <Route path="C120" element={<SuspenseContainer JsxElement={<C120 />} />} />
              <Route path="P2_1" element={<SuspenseContainer JsxElement={<P2_1 />} />} />
              <Route path="P2_2" element={<SuspenseContainer JsxElement={<P2_2 />} />} />
              <Route path="P4L" element={<SuspenseContainer JsxElement={<P4L />} />} />
              <Route path="PrimaPower1" element={<SuspenseContainer JsxElement={<PrimaPower1 />} />} />
              <Route path="PrimaPower2" element={<SuspenseContainer JsxElement={<PrimaPower2 />} />} />
              <Route path="S2" element={<SuspenseContainer JsxElement={<S2 />} />} />
              <Route path="S4P4" element={<SuspenseContainer JsxElement={<S4P4 />} />} />
              <Route path="S4Xe" element={<SuspenseContainer JsxElement={<S4Xe />} />} />
              <Route path="S4XeP4" element={<SuspenseContainer JsxElement={<S4XeP4 />} />} />
              <Route path="TC1000" element={<SuspenseContainer JsxElement={<TC1000 />} />} />
              <Route path="TC3000R" element={<SuspenseContainer JsxElement={<TC3000R />} />} />
              <Route path="TruPunch5000" element={<SuspenseContainer JsxElement={<TruPunch5000 />} />} />
              <Route path="TruBend7030" element={<SuspenseContainer JsxElement={<TruBend7030 />} />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </HomeLayout>


      </div>
    );
  }
}

export default App;
